export enum UspsValidationState {
  Validated = 'validated',
  SkippedByAdmin = 'skipped_by_admin',
  InvalidConfirmed = 'invalid_confirmed_by_client',
  NotChecked = 'not_checked',
  Invalid = 'invalid',
}

export const ADDRESS_LENGTH_LIMIT = 71; // courier limit for line_1 + line_2 + line_3
